export function getCanvas (w, h) {
  var canvas = document.createElement('canvas')
  canvas.width = w || 512
  canvas.height = h || 512
  return canvas
}
export function getContext (canvas, w, h) {
  canvas = canvas || getCanvas(w, h)
  canvas.width = w || canvas.width
  canvas.height = h || canvas.height
  return canvas.getContext('2d')
}



/** WEBPACK FOOTER **
 ** ./src/utils/canvas.js
 **/